APPS.shows.removed = (function(){	
    var show = function(id){
        APP.getView().showChildView('mainRegion', new removedShow() )
        			
		window.document.title = id;
		if(typeof ga != "undefined"){ 
			ga('set','title',id);
			ga('send','pageview');
		}
		if(typeof gtag != "undefined"){
			gtag('set', { 'page_title': id });
			gtag('event', 'page_view');
		}
		if(typeof submitVisitorDetails ==="function"){ submitVisitorDetails(APP_CONFIG.rpi.server, APP_CONFIG.rpi.clientId, id, '0', false, true); }
		
    }
    
    
    /***********************************************************************
	 ***********************************************************************
	    VIEWS 
	 ***********************************************************************
	 ***********************************************************************/
        var removedShow = Mn.View.extend({
		     className:"page_removed_show mt8 pb8"
	        ,template:_.template("<div style='text-align:center'><p class='mb0'>Sorry, this program is no longer available. If you're still in the mood to listen to something, please <a href='/radio'>try one of our other programs</a>.</p></div>")
	    })
	    
    return {
        show:show
    }
})();


